import firebaseApp from "./FirebaseConfig.js";

import {
    doc,
    // getDocs,
    collection,
    // query,
    // where,
    getDoc,
    // setDoc,
    addDoc,
    // Timestamp,
    updateDoc,
    increment,
    onSnapshot,
    // arrayUnion,
} from "firebase/firestore";

const firestore = firebaseApp.firestore;

// ============================
// Functions for writing signup data to Firestore
// ============================

// Write NativeForms sign-up data to Firestore
export const writeSignupData = async (eventId, signupData) => {
    // Get a reference to the "signup_data" sub-collection, within the Firestore doc corresponding to the current event
    const collectionRef = collection(
        firestore,
        `events/${eventId}/signup_data`
    );
    const counterDocRef = doc(firestore, `events/${eventId}/signup_data`, "--stats--");

    // Perform write operations
    try {
        // Write a new document with auto-generated docId to the "signup_data" collection
        await addDoc(collectionRef, signupData);

        // Increment the counter
        await updateDoc(counterDocRef, { signupCount: increment(1) });
    } catch (error) {
        console.error(error.message);
    }
};


// ============================
// Functions for retrieving event data from Firestore
// ============================

// Retrieve event meta data
export const retrieveEventMetaData = async (eventId) => {
    const docRef = doc(firestore, `events`, eventId);
    try {
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            const docData = await docSnap.data()
            return docData;
        } else {
            console.log("No such document.");
            return null;
        }
    } catch (error) {
        console.error(error.message);
    }
};

// Subscribe to listen for updates to event metrics data
// export const listenForMetricsUpdate = async (eventId, callbackFunction) => {
//     const docRef = doc(firestore, `events/${eventId}/signup_data`, "--stats--");
//     const unsub = onSnapshot(docRef, (doc) => callbackFunction(doc.data()));
// }